module.exports = __webpack_public_path__ + "img/ar_text.2adcb36d.png";